<template>
  <div class="flex-al-strech flex-jc-ard pop-more">
    <div class="flex-50 pd-l-40 pd-r-20" style="border-right: 1px dashed #3A909D">
      <p v-triangle class="fs-bold">{{ $l('CompanyInformation') }}</p>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanySerialNo') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.serialNo }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Staff') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.staffCount }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyNameEnglish') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.name }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyNameNativeLanguage') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.nativeName }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('PositioninOrganizationChart') }}</div>
        <div class="flex-45 fs-int">{{ $l(companyPosition[companyDetail.level]?.title) }}</div>
      </div>

      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('RegisterCountrySAR') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.regCountry?.name }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('AreaCodeofCountryorSAR') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.regCountryCode }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('City') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.regCity?.name }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('AreaCodeofCity') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.regCityCode }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('AboutCompanyName') }}</div>
        <div class="flex-45 fs-int">
          <div>{{ $l(aboutCompanyName[companyDetail.regLevel]?.title) }}</div>
          <!--          <div class="sp-color-7">{{ $l(aboutCompanyName[companyDetail.regLevel]?.tip) }}</div> -->
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('ShiplusAccessIdentity') }}</div>
        <div class="flex-45 fs-int">
          <div class="mg-b-10">
            <div>{{ $l(companyCategory[companyDetail.identity]?.title) }}</div>
            <div class="sp-color-7">{{ $L(companyCategory[companyDetail.identity]?.tip) }}</div>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyCategory') }}</div>
        <div class="flex-45 fs-int">
          <div v-if="companyDetail.privSign === 1">
            <div>{{ $L('SigningRightCompany') }}</div>
            <div class="sp-color-7">{{ $L('SigningRightCompanyTip') }}</div>
          </div>
          <div v-else>NIL</div>
        </div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('RegistrationNo') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail?.registrationNo }}</div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('RegisteredOfficeAddress') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.regAddress }}</div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('IncorporationDate') }}</div>
        <div class="flex-45 fs-int">{{ getDateToFormatEn(companyDetail.incorporationDate, false) }}</div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Incorporator') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.incorporator }}</div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Assets') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.otherAssets }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Website') }}</div>
        <div class="flex-45 fs-int">{{ companyDetail.website }}</div>
      </div>
      <!--      <div class="flex-jc-bt pop-item"> -->
      <!--        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Others') }}</div> -->
      <!--        <div class="flex-45 fs-int">{{ companyDetail.otherRemark }}</div> -->
      <!--      </div> -->

      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyProfile') }}</div>
        <div class="flex-45 fs-int">
          <SpSection :content="companyDetail.introduction" />
        </div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('FixtureList') }}</div>
        <div class="flex-45 fs-int">
          <SpSection :content="companyDetail.tradeRemark" />
        </div>
      </div>
    </div>
    <SpDivider :height="1" />
    <div class="flex-40">
      <p v-triangle class="fs-bold">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CertificateofRegister') }}</div>
        <div class="flex-45 fs-int">
          <!--          <template v-for="img in corpCertificateFileList"> -->
          <!--            <el-image -->
          <!--              v-if="img.url.substr(img.url.lastIndexOf('.') + 1) != 'pdf'" -->
          <!--              style="width: 28px; height: 40px;margin-right: 20px" -->
          <!--              :src="img.url" -->
          <!--              :preview-src-list="corpCertificateFileList.map(file => file.url)" /> -->
          <!--            <iframe v-else class="preview-iframe" scrolling="no" -->
          <!--                    width="28px" height="40px" frameborder="0" :src="img.url" /> -->
          <!--          </template> -->

          <ImgListPreview :list="corpCertificateFileList" />
          <!--          <SpUploadGroup ref="corpCertificate" -->
          <!--                         :width="28" -->
          <!--                         :height="40" -->
          <!--                         :disabled="true" -->
          <!--                         :default-files="corpCertificateFileList" /> -->
        </div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Others') }}</div>
        <div class="flex-45 fs-int">
          <!--          <el-image -->
          <!--            v-for="img in registrationOtherFileList" -->
          <!--            style="width: 28px; height: 40px; margin-right: 20px" -->
          <!--            :src="img.url" -->
          <!--            :preview-src-list="registrationOtherFileList.map(file => file.url)" /> -->
          <!--          <SpUploadGroup ref="registrationOther" -->
          <!--                         :width="28" -->
          <!--                         :height="40" -->
          <!--                         :disabled="true" -->
          <!--                         :default-files="registrationOtherFileList" /> -->
          <ImgListPreview :list="registrationOtherFileList" />
        </div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Method1') }}</div>
        <div class="flex-45 fs-int">
          <SpUpload
            style="margin-left: -20px"
            :disabled="true"
            :default-files="fixtureListFiles"
            file-type="corp/trade/file"
            type="primary" />
        </div>
      </div>
      <div class="flex-jc-bt pop-item-close">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Method2') }}</div>
        <div class="flex-45 fs-int">
          <!--          <el-image -->
          <!--            v-for="img in tradeRecordPics" -->
          <!--            style="width: 28px; height: 40px;margin-right: 20px" -->
          <!--            :src="img.url" -->
          <!--            :preview-src-list="tradeRecordPics.map(file => file.url)" /> -->
          <!--          <SpUploadGroup ref="tradeRecordPics" -->
          <!--                         :width="28" -->
          <!--                         :height="40" -->
          <!--                         :disabled="true" -->
          <!--                         :default-files="tradeRecordPics" /> -->
          <ImgListPreview :list="tradeRecordPics" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEnterpriseCorpDetailApi } from '@/request/APIs/company'
import { getDateToFormatEn, formatFiles } from '@/utils/convert'
import { reactive } from 'vue'
import { ABOUT_COMPANY_NAME, ACCESS_IDENTITY, COMPANY_POSITION } from '@/config/company'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpUpload from '@/components/common/SpUpload'
import SpSection from '@/components/common/SpSection'
import ImgListPreview from '../../common/ImgListPreview'

export default {
  name: 'CompanyDetailDrawer',
  components: { ImgListPreview, SpUpload, SpUploadGroup, SpSection },
  nameSpace: 'company.CompanyDynamics',
  props: {
    id: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      companyDetail: {},
      companyCategory: ACCESS_IDENTITY,
      companyPosition: COMPANY_POSITION,
      aboutCompanyName: ABOUT_COMPANY_NAME,
      getDateToFormatEn
    }
  },

  computed: {
    companyLogo () {
      const list = []
      if (this.companyDetail.logo) {
        const files = this.companyDetail.logo
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key
          })
        })
      }
      return list
    },

    corpCertificateFileList () {
      return formatFiles(this.companyDetail, 'certificate')
    },

    registrationOtherFileList () {
      return formatFiles(this.companyDetail, 'otherRegistrationFiles')
    },

    tradeRecordPics () {
      return formatFiles(this.companyDetail, 'tradeRecordPics')
    },

    fixtureListFiles () {
      const list = []
      if (this.companyDetail.tradeRecordFiles?.files) {
        const files = this.companyDetail.tradeRecordFiles.files
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key,
            name: key
          })
        })
      }
      return list
    }
  },

  watch: {
    id (n) {
      this.getDetail(n)
    }
  },

  methods: {
    getDetail (id) {
      getEnterpriseCorpDetailApi(id).then(res => {
        this.companyDetail = res.data
      })
    }

  }
}
</script>

<style scoped lang="less" >
.preview-iframe{
  overflow: hidden;
  pointer-events: none;
}
.pop-more{
  .pop-item{
    padding: 10px 0;
  }
  .pop-item-close{
    padding: @gap/5 0;
  }
  .pop-item-title{
    text-align: right;
    font-size: 16px;
    font-family: Arial;
    font-weight: 400;
    opacity: 80;
  }
  .fs-int{
    font-size: 16px;
  }
}
</style>
